import { render, staticRenderFns } from "./NotItem.vue?vue&type=template&id=3aa6f244&scoped=true&"
import script from "./NotItem.vue?vue&type=script&lang=js&"
export * from "./NotItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa6f244",
  null
  
)

export default component.exports